import {durationUnits} from 'utilities/helper/durationUnitsOption';

export const initialValues: IAuctionInitialValues = {
  price: '',
  duration: '',
  duration_unit: durationUnits[0].value?.toString(),
};
